import React from "react";
import SubBanner from "./components/SubBanner";
import Follow from "./components/Follow";

function Fruits() {
  return (
    <>
      <SubBanner title="Fruits" />

      <section className="shop1-con prod position-relative">
        <div className="container-fluid p-5">

          <div className="row shop-products-con">
            <ProductCard
              image="../assets/product-images/Strawberry.png"
              name="Strawberry"
              desc="A refreshing burst of sweet strawberries in every creamy scoop."
            />

            <ProductCard
              image="../assets/product-images/Jamun.png"
              name="Jamun"
              desc="A unique fruity indulgence with the bold and nostalgic taste of jamun."
            />

            <ProductCard
              image="../assets/product-images/Blueberry.png"
              name="Blueberry"
              desc="Smooth and fruity gelato infused with the sweet-tangy charm of blueberries."
            />

            <ProductCard
              image="../assets/product-images/Chiiku.png"
              name="Chikoo"
              desc="Creamy perfection blended with the naturally sweet flavour of ripe chikoo."
            />
          </div>

          <div className="row shop-products-con mt-3">

            <ProductCard
              image="../assets/product-images/Mango.png"
              name="Mango"
              desc="Tropical richness crafted with the luscious taste of ripe mangoes."
            />

            <ProductCard
              image="../assets/product-images/Mango Sorbet.png"
              name="Mango Sorbet"
              desc="A light and refreshing tropical escape bursting with mango freshness."
            />

            <ProductCard
              image="../assets/product-images/Coconut & Custard Apple.png"
              name="Tender Coconut"
              desc="Fresh, creamy gelato made with real tender coconut and soft coconut bits for a naturally refreshing tropical experience."
            />
            <ProductCard
              image="../assets/product-images/Coconut & Custard Apple.png"
              name="Custard Apple"
              desc="Silky, creamy gelato infused with the rich sweetness of ripe custard apple for a smooth, fruity indulgence."
            />
          </div> 

        </div>
      </section>

      <Follow />
    </>
  );
}

// Product Card
function ProductCard({ image, name, desc }) {
  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
      <div className="classic-box hover-card">
        <div className="classic_image_box box1">
          <img src={image} alt={name} />
        </div>

        <div className="hover-content">
          <h6 className="hover-title">{name}</h6>
          <p className="hover-desc">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default Fruits;